module.exports = __webpack_public_path__ + "45b2049d4d670f65a584d664b97c6e06.png";